export default {
      id: "arrow-right-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#arrow-right-usage",
      toString: function () {
        return this.url;
      }
    }